import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SchedulerTaskClass;
function SchedulerTask() {
  if (SchedulerTaskClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SchedulerTask', VOID, VOID, [Runnable()]);
    SchedulerTaskClass = $;
  }
  return SchedulerTaskClass;
}
//region block: exports
export {
  SchedulerTask as SchedulerTaskrk35h6752rti,
};
//endregion

//# sourceMappingURL=SchedulerTask.mjs.map
